import { memoize } from "lodash";
import {
  deviceDetect,
  isMobileOnly,
  isTablet,
  isSmartTV,
  isAndroid,
  isIOS,
  isWinPhone
} from "react-device-detect";
class CoreDeviceStore {
  getDeviceData = () => {
    const {
      isBrowser,
      browserMajorVersion,
      browserFullVersion,
      browserName,
      engineName,
      engineVersion,
      osName,
      osVersion,
      userAgent
    } = deviceDetect(navigator.userAgent);

    return {
      isBrowser,
      isSmartTV,
      isTablet,
      isMobile: isMobileOnly,
      browserMajorVersion,
      browserFullVersion,
      browserName,
      engineName,
      engineVersion,
      osName,
      osVersion,
      userAgent,
      os: isAndroid
        ? "ANDROID"
        : isIOS
          ? "IOS"
          : isWinPhone
            ? "WINDOWS"
            : isBrowser
              ? "BROWSER"
              : ""
    };
  };
}
const getCoreDeviceStore = memoize(
  () => new CoreDeviceStore(),
  () => 1
);
export default getCoreDeviceStore;
